
const messages = () => import('../../components/messaging/Messages')

// const Table = () => import('@/../../coreui/components/ServerTable')

export default function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Notifications')
      || allowed.includes('Messaging')
      || allowed.includes('Messages')
      )  {
    return [
    // {
    //   name: 'MsgSendMessage',
    //   path: '/MsgSendMessage',
    //   component: sendAlert
    // },
    {
      name: 'MsgMessages', 
      path: '/MsgMessages', 
      component: messages
      // component: Table, 
      // props: {
      //   schema: 'sch_inf_global', 
      //   table: 'inf_global'
      // }
    }
  ] } else return []
}

